import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { Link, useParams, useSearchParams } from "react-router-dom";

import { Paragraph, Small } from "@fronterahealth/frontera-ui-components";

import { useGetRulePackage, useListPayorTypes } from "@api/rest/types-and-hooks";
import { PackageCard } from "@pages/QARules/PackageCard";
import { PackageUsedBy } from "@pages/QARules/PackageUsedBy";
import { QARulesParam, QA_RULES_PATH } from "@pages/QARules/constants";

/** One package — or, with `?rule=`, one of its rules — and everywhere it's used. */
export const QAPackageDetail: React.FC = () => {
  const { packageId } = useParams<{ packageId: string }>();
  const [searchParams] = useSearchParams();
  const numericId = Number(packageId);
  const focusedRuleId = Number(searchParams.get(QARulesParam.RULE)) || undefined;

  const { data, isLoading } = useGetRulePackage(numericId, { query: { enabled: !!numericId } });
  const pkg = data?.status === 200 ? data.data : undefined;
  const { data: payorData } = useListPayorTypes();
  const payorTypes = payorData?.status === 200 ? payorData.data.results : [];

  return (
    <div className="flex max-w-5xl flex-col gap-8 px-16 py-8">
      <Link
        to={QA_RULES_PATH}
        className="flex w-fit items-center gap-1 text-sm text-text-secondary hover:text-text-primary"
      >
        <ArrowLeftIcon className="h-4 w-4" />
        All packages
      </Link>

      {isLoading && <Small colorType="secondary">Loading...</Small>}
      {!isLoading && !pkg && (
        <Paragraph className="text-text-secondary">
          {data?.status === 404 ? "Package not found." : "Couldn't load this package."}
        </Paragraph>
      )}
      {pkg && (
        <>
          <PackageCard
            key={`${pkg.id}-${focusedRuleId ?? "all"}`}
            pkg={pkg}
            payorTypes={payorTypes}
            defaultExpanded
            focusedRuleId={focusedRuleId}
          />
          <PackageUsedBy pkg={pkg} focusedRuleId={focusedRuleId} />
        </>
      )}
    </div>
  );
};
